module.exports = {"520423001":"白马湖街道","520423002":"环翠街道","520423003":"丁旗街道","520423004":"双龙山街道","520423102":"黄果树镇","520423105":"马厂镇","520423107":"良田镇","520423108":"扁担山镇","520423109":"募役镇","520423110":"江龙镇","520423111":"本寨镇","520423112":"六马镇","520423204":"沙子乡","520423206":"革利乡","520423210":"简嘎乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520423.json
// module id = 2480
// module chunks = 0